<template>
  <div v-if="$store.state.global.devices" id="devicesTab">
    <b-row>
      <b-col>
        <b-form-group>
          <search-input v-model="query" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-col class="text-right">
          <b-button v-router-link="{ name:'device-editor', query:{ manufacturer_id: $store.state.global.manufacturer.id }}" variant="outline-primary">
            <i class="fa fa-plus-circle" /> Add Device
          </b-button>
        </b-col>
      </b-col>
    </b-row>
    <b-card-group columns>
      <!-- | filter : query -->
      <b-card no-body
        v-for="device in displayDevices"
        :key="device.id"
        v-router-link="{ name:'device-detail', params: device }"
        
      >
        <b-card-body>
          <h3>{{ device.name }}</h3>
        </b-card-body>
      </b-card>
    </b-card-group>
    <div v-if="displayDevices.length == 0" class="text-center">
      No results
    </div>
  </div>
</template>

<script>
import $search from '@/services/search';
import SearchInput from '@/components/SearchInput';

export default {
  name: 'ManufacturerDevicesTab',

  components: {
    SearchInput,
  },

  data() {
    return {
      query: '',
    };
  },

  computed: {
    displayDevices() {
      return $search(this.$store.state.global.devices, this.query);
    },
  },
};
</script>
